import utils from '@eitje/utils'
import {AnimatedIcon} from '../animated_icon'
import {Layout} from '../layout'
import {Text, Title} from '../text'
import {childrenWithClonedProps} from '../../helpers'
import {t} from '@eitje/bridge'
import './styles.less'

const ANIMATION_SIZES = {
	default: 96,
	small: 72,
	mini: 48,
}

const getTranslation = (type, {name, ...rest}) => {
	// the default 'type' (title or subtitle) is a boolean to follow naming convention.
	// This can be overwritten by making the type a custom string or function
	const value = rest[type]
	if (typeof value === 'object') return t(value.key, value.opts)
	let key = typeof value === 'string' ? value : type
	if (name) key = `placeholders.${name}.${key}`
	return t(key)
}

export const Placeholder = props => {
	const {
		children = [],
		size = 'default',
		title = true,
		subtitle = true,
		animation,
		layoutProps = {},
		buttonLayoutProps = {},
		customButtons = [],
		padding = '32 0',
		customChildren,
	} = props
	const animationSize = ANIMATION_SIZES[size]
	const isDefault = size === 'default'
	const TitleComponent = isDefault ? Title : Text

	const otherButtons = childrenWithClonedProps({
		children,
	})

	const buttons = childrenWithClonedProps({
		children: [...otherButtons, ...customButtons].filter(Boolean),
		props: {size: size === 'mini' ? 'small' : 'regular'},
	})

	return (
		<Layout className="placeholder" direction="vertical" horizontal="center" vertical="center" gap={8} padding={padding} {...layoutProps}>
			{animation && <AnimatedIcon size={animationSize} animation={animation} play="auto" />}
			{title && <TitleComponent bold>{getTranslation('title', props)}</TitleComponent>}
			{subtitle && (
				<Text center small={!isDefault}>
					{getTranslation('subtitle', props)}
				</Text>
			)}
			{utils.exists(buttons) && (
				<Layout margin="8 0" horizontal="center" {...buttonLayoutProps}>
					{buttons}
				</Layout>
			)}
			{customChildren && customChildren}
		</Layout>
	)
}
